import React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';

import * as types from '../../reducer/constants';

const FieldOverflow = ({ form, dispatchServiceData }) => {
  const { overflow } = form;
  const overflowValue = overflow || overflow === 0 ? overflow : '';
  const minValue = -50;
  const maxValue = 1000;

  const onChangeDispatch = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_OVERFLOW, value })
  }

  const onChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      return onChangeDispatch(null);
    }
    if (/^((?:-){0,1}[0-9]*)$/.test(value)) {
      onChangeDispatch(value);
    }
  };

  const onBlur = (e) => {
    const value = e.target.value;
    const numberValue = parseInt(value, 10);
    if (!_.isNaN(numberValue)) {
      if (value > maxValue) {
        return onChangeDispatch(maxValue);
      }
      if (value < minValue) {
        return onChangeDispatch(minValue);
      }
      return onChangeDispatch(numberValue);
    }
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="overflow">Overflow, %</ControlLabel>
        <FormControl type="text" id="overflow" name="overflow" value={overflowValue} onChange={onChange} onBlur={onBlur} />
      </FormGroup>
    </>
  );
};

FieldOverflow.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldOverflow;
